module.exports = __webpack_public_path__ + "static/media/hold_email.d48820d0.svg";